<template>
  <v-navigation-drawer
    v-model="drawer"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    app
    width="300"
    v-bind="$attrs"
  >
    <!-- Header Section -->
    <div class="drawer-header">
      <!-- HR Logo Section -->
      <div class="hr-logo-section">
        <div class="hr-logo">
          <span class="logo-h">H</span>
          <span class="logo-r">R</span>
        </div>
        <div class="logo-subtitle">
          Office of Vocational Education Commission
        </div>
      </div>

      <v-divider class="header-divider" />

      <v-list dense nav class="transparent">
        <v-list-item class="user-profile-section">
          <v-list-item-avatar class="profile-avatar" size="64">
            <div class="avatar-background">
              <v-img
                src="https://www.bloggang.com/data/b/bigstory/picture/1449748275.gif"
                class="avatar-image"
              />
            </div>
          </v-list-item-avatar>

          <v-list-item-content class="user-info">
            <v-list-item-title class="user-id">{{
              user.id_card
            }}</v-list-item-title>
            <v-list-item-title class="user-name">
              {{ user.title_s }}{{ user.frist_name }} {{ user.last_name }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>

    <v-divider class="glass-divider" />

    <!-- Navigation Menu -->
    <v-list expand nav class="navigation-menu transparent">
      <!-- Profile Link -->
      <v-list-item
        to="/UserProfile"
        class="nav-item"
        exact-active-class="nav-item-active"
      >
        <v-list-item-icon class="nav-icon">
          <v-icon>mdi-account</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="nav-title"
          >ข้อมูลผู้ใช้งานระบบ</v-list-item-title
        >
      </v-list-item>

      <v-list nav dense class="nav-group">
        <v-list-item-group color="primary">
          <v-list-item
            v-for="(item, i) in itemsGeneral"
            :key="i"
            :to="item.to"
            class="sub-nav-item"
            exact-active-class="sub-nav-item-active"
          >
            <v-list-item-icon>
              <v-icon class="sub-nav-icon" v-text="item.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title
                class="sub-nav-title"
                v-text="item.title"
              ></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <!-- Work History Link -->
      <v-list-item
        v-if="user.user_status != 'gov_em'"
        to="/personnel_work_history"
        class="nav-item"
        exact-active-class="nav-item-active"
      >
        <v-list-item-icon class="nav-icon">
          <v-icon>mdi-access-point-network</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="nav-title"
          >ข้อมูลประวัติการรับราชการ</v-list-item-title
        >
      </v-list-item>

      <!-- Work History Link -->
      <v-list-item
        v-if="user.user_status === 'gov_em'"
        to="/personnel_govem_assesment"
        class="nav-item"
        exact-active-class="nav-item-active"
      >
        <v-list-item-icon class="nav-icon">
          <v-icon>mdi-map-marker-alert</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="nav-title"
          >9.ผลการประเมินการปฏิบัติงานย้อนหลัง</v-list-item-title
        >
      </v-list-item>

      <!-- Assistant Teacher Link (Conditional) -->
      <v-list-item
        v-if="user.position_name === 'ครูผู้ช่วย'"
        to="/assistant_teacher"
        class="nav-item special-item"
        exact-active-class="nav-item-active"
      >
        <v-list-item-icon class="nav-icon">
          <v-icon>mdi-account-arrow-right</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="nav-title"
          >การประเมินครูผู้ช่วย</v-list-item-title
        >
        <v-chip class="special-badge" x-small>
          <v-icon small left>mdi-star</v-icon>
          พิเศษ
        </v-chip>
      </v-list-item>
    </v-list>

    <!-- Footer Section -->
    <div class="">
      <v-divider class="footer-divider" />
      <v-list class="">
        <v-list-item class="logout-section" @click="logout">
          <v-list-item-icon class="nav-icon">
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="nav-title">ออกจากระบบ</v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapState } from "vuex";

export default {
  name: "DashboarduserDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    ApiKey: "HRvec2021",
    user_data: {},
    user: {},
    loginuser: JSON.parse(sessionStorage.getItem("user")) || 0,
    itemsGeneral: [
      {
        title: "1.ความรู้ คุณวุฒิการศึกษา",
        icon: "mdi-school",
        to: "/personnel_education"
      },

      {
        title: "2.ลูกเสือวิสามัญอาชีวศึกษา",
        icon: "mdi-school-outline",
        to: "/personnel_self_scout"
      },

      {
        title: "3.การปฏิบัติหน้าที่",
        icon: "mdi-account-network",
        to: "/personnel_duty"
      },
      {
        title: "4.อายุราชการ",
        icon: "mdi-account-star",
        to: "/service_age"
      },
      {
        title: "5.ผลการปฏิบัติงาน",
        icon: "mdi-trophy-award",
        to: "/personnel_award"
      },
      {
        title: "6.ระยะเวลาการปฏิบัติหน้าที่",
        icon: "mdi-timetable",
        to: "/period_current"
      },
      {
        title: "7.การรักษาวินัยฯ",
        icon: "mdi-alarm-light",
        to: "/personnel_discipline"
      },
      {
        title: "8.การพัฒนาตนเอง/วิชาชีพ",
        icon: "mdi-human-handsup",
        to: "/personnel_experience"
      },
      {
        title: "9.สภาพความยากลำบาก",
        icon: "mdi-map-marker-alert",
        to: "/work_difficulty"
      },

      {
        title: "10.รายงานการเดินทางราชการ",
        icon: "mdi-airplane",
        to: "/tripReport"
      }
    ]
  }),

  computed: {
    ...mapState(["barColor", "barImage"]),
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(val) {
        this.$store.commit("SET_DRAWER", val);
      }
    },
    profile() {
      return {
        avatar: true,
        title: ""
      };
    }
  },

  async mounted() {
    let result;
    let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
    result = await this.$http.post("personnel_temporary.php", {
      ApiKey: this.ApiKey,
      id_card: userSession.id_card
    });
    this.user = result.data;
  },

  methods: {
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: this.$t(item.title)
      };
    },
    logout() {
      Swal.fire({
        title: "ออกจากระบบ",
        text: "คุณต้องการออกจากระบบหรือไม่?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#e74c3c",
        cancelButtonColor: "#95a5a6",
        confirmButtonText: "ออกจากระบบ",
        cancelButtonText: "ยกเลิก"
      }).then(result => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          this.$router.push("/");
        }
      });
    }
  }
};
</script>

<style scoped>
/* Main Drawer Styling */
.modern-drawer {
  background: linear-gradient(
    135deg,
    #2c3e50 0%,
    #34495e 50%,
    #2c3e50 100%
  ) !important;
  border-right: 2px solid #e74c3c !important;
  position: relative;
  overflow: hidden;
  width: 300px !important;
}

/* Background Elements */
.drawer-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.floating-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.shape {
  position: absolute;
  border-radius: 50%;
  animation: float 8s ease-in-out infinite;
}

.shape-1 {
  width: 60px;
  height: 60px;
  top: 15%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 80px;
  height: 80px;
  top: 60%;
  right: 15%;
  animation-delay: 3s;
}

.shape-3 {
  width: 40px;
  height: 40px;
  top: 35%;
  right: 25%;
  animation-delay: 6s;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(44, 62, 80, 0.95) 0%,
    rgba(52, 73, 94, 0.98) 30%,
    rgba(44, 62, 80, 1) 70%,
    rgba(231, 76, 60, 0.05) 100%
  );
}

/* Header Section */
.drawer-header {
  position: relative;
  z-index: 1;
  padding: 5px 10px;
  backdrop-filter: blur(20px);
}

/* HR Logo Section */
.hr-logo-section {
  text-align: center;
  margin-bottom: 16px;
  animation: fadeInUp 0.8s ease-out;
}

.hr-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
}

.logo-h {
  font-size: 2.5rem;
  font-weight: 900;
  color: #2c3e50;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  margin-right: -4px;
}

.logo-r {
  font-size: 2.5rem;
  font-weight: 900;
  color: #e74c3c;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.logo-subtitle {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
  line-height: 1.2;
}

.header-divider {
  border-color: rgba(231, 76, 60, 0.4) !important;
}

.user-profile-section {
  padding: 5px 0 !important;
  animation: fadeInUp 0.8s ease-out;
}

.profile-avatar {
  margin-right: 5px !important;
  position: relative;
}

.avatar-background {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
}

.avatar-background::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  animation: shimmer 3s linear infinite;
}

.avatar-image {
  border-radius: 50%;
  width: 56px;
  height: 56px;
}

.user-id {
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  margin-bottom: 4px !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.user-name {
  font-size: 1.1rem !important;
  font-weight: 700 !important;
  line-height: 1.3 !important;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

/* Glass Divider */
.glass-divider {
  border-color: #e74c3c !important;
  margin: 0 16px;
  opacity: 0.6;
}

/* Navigation Menu */
.navigation-menu {
  position: relative;
  z-index: 1;
  padding: 8px 0 12px 0; /* Add bottom padding to prevent overlap with footer */
  background: transparent !important;
  max-height: calc(100vh - 240px);
  overflow-y: auto;
}

.transparent {
  background-color: transparent !important;
}

/* Navigation Items */
.nav-item {
  margin: 4px 12px;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
  backdrop-filter: blur(10px);
  border: 1px solid transparent;
  animation: slideInLeft 0.6s ease-out;
  position: relative;
  overflow: hidden;
}

.nav-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 0;
  background: linear-gradient(90deg, #e74c3c, #c0392b);
  transition: width 0.3s ease;
  border-radius: 12px 0 0 12px;
}

.nav-item:hover {
  background: rgba(231, 76, 60, 0.15) !important;
  border-color: rgba(231, 76, 60, 0.4);
  transform: translateX(4px);
  box-shadow: 0 4px 15px rgba(231, 76, 60, 0.2);
}

.nav-item:hover::before {
  width: 4px;
}

.nav-item-active {
  background: rgba(231, 76, 60, 0.25) !important;
  border-color: rgba(231, 76, 60, 0.6) !important;
  box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3);
}

.nav-item-active::before {
  width: 4px;
}

.nav-icon {
  margin-right: 12px !important;
  min-width: auto !important;
}

.nav-title {
  font-weight: 600 !important;
  font-size: 0.95rem !important;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

/* Group Items */
.nav-group .v-list-group__header {
  margin: 4px 12px !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
  backdrop-filter: blur(10px);
  border: 1px solid transparent;
  position: relative;
  overflow: hidden;
}

.nav-group .v-list-group__header::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 0;
  background: linear-gradient(90deg, #e74c3c, #c0392b);
  transition: width 0.3s ease;
  border-radius: 12px 0 0 12px;
}

.nav-group .v-list-group__header:hover {
  background: rgba(231, 76, 60, 0.15) !important;
  border-color: rgba(231, 76, 60, 0.4);
}

.nav-group .v-list-group__header:hover::before {
  width: 4px;
}

.nav-group .v-list-group__header--active {
  background: rgba(231, 76, 60, 0.25) !important;
  border-color: rgba(231, 76, 60, 0.6) !important;
}

.nav-group .v-list-group__header--active::before {
  width: 4px;
}

.group-title {
  font-weight: 700 !important;
  font-size: 0.95rem !important;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

/* Sub Navigation Items */
.sub-nav-item {
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  backdrop-filter: blur(5px);
  border: 1px solid transparent;
  min-height: 36px !important;
  position: relative;
  overflow: hidden;
}

.sub-nav-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 0;
  background: linear-gradient(90deg, #e74c3c, #c0392b);
  transition: width 0.3s ease;
  border-radius: 8px 0 0 8px;
}

.sub-nav-item:hover {
  background: rgba(231, 76, 60, 0.1) !important;
  border-color: rgba(231, 76, 60, 0.3);
  transform: translateX(2px);
}

.sub-nav-item:hover::before {
  width: 3px;
}

.sub-nav-item-active {
  background: rgba(231, 76, 60, 0.2) !important;
  border-color: rgba(231, 76, 60, 0.5) !important;
}

.sub-nav-item-active::before {
  width: 3px;
}

.sub-nav-title {
  font-weight: 500 !important;
  font-size: 0.9rem !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* Special Item */
.special-item {
  position: relative;
  overflow: visible !important;
}

.special-badge {
  background: linear-gradient(45deg, #e74c3c, #c0392b) !important;
  font-size: 0.7rem !important;
  font-weight: 600 !important;
  height: 20px !important;
  margin-left: 8px;
  box-shadow: 0 2px 8px rgba(231, 76, 60, 0.3);
}

/* Logout Section */
.logout-section {
  margin: 20px 12px 8px 12px !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

.logout-section:hover {
  background: rgba(231, 76, 60, 0.3) !important;
  border-color: rgba(231, 76, 60, 0.6) !important;
  transform: translateX(2px);
}

/* Footer Section */
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  padding: 12px 16px;
  backdrop-filter: blur(20px);
  border-top: 2px solid #e74c3c;
}

.footer-divider {
  border-color: rgba(231, 76, 60, 0.4) !important;
  margin: 0 0 8px 0 !important;
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
}

.footer-text {
  font-size: 0.75rem;
  font-weight: 600;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

/* Animations */
@keyframes float {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translateY(-15px) rotate(180deg) scale(1.1);
    opacity: 0.9;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  100% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .modern-drawer {
    width: 280px !important;
  }

  .user-name {
    font-size: 0.9rem !important;
  }

  .nav-title,
  .group-title {
    font-size: 0.85rem !important;
  }

  .sub-nav-title {
    font-size: 0.8rem !important;
  }
}

/* Override Vuetify Defaults */
.v-navigation-drawer .v-list {
  background: transparent !important;
}

.v-navigation-drawer .v-divider {
  border-color: rgba(231, 76, 60, 0.4) !important;
}

/* Scrollbar Styling */
.navigation-menu::-webkit-scrollbar {
  width: 4px;
}

.navigation-menu::-webkit-scrollbar-track {
  background: rgba(44, 62, 80, 0.8);
}

.navigation-menu::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #e74c3c, #c0392b);
  border-radius: 2px;
}

.navigation-menu::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #c0392b, #a93226);
}

.modern-drawer::-webkit-scrollbar {
  width: 4px;
}

.modern-drawer::-webkit-scrollbar-track {
  background: rgba(44, 62, 80, 0.8);
}

.modern-drawer::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #e74c3c, #c0392b);
  border-radius: 2px;
}

.modern-drawer::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #c0392b, #a93226);
}
</style>
